import { registerBottomSheets, BottomSheetComponent } from '@bonanza-social/navigation';

import InstantWheel from './InstantWheelBottomSheet';

const bottomSheets = {
  InstantWheel,
};

registerBottomSheets('instantWheel', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    instantWheel: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
